import { InfoIcon } from './components/InfoIcon'
import classes from './styles.module.scss'

interface ReferFriendImportantInfoProps {
  title: string
  text: string
}

export const ReferFriendImportantInfo = ({ title, text }: ReferFriendImportantInfoProps) => {
  return (
    <div className={classes.infoContainer}>
      <InfoIcon className={classes.infoIcon} />
      <div className={classes.infoWrapper}>
        <span className={classes.infoTitle}>{title}</span>
        <span className={classes.infoText}>{text}</span>
      </div>
    </div>
  )
}
